var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"title":"Generate Letters (MR)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }